import { ProductType } from '@/@types';
import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import { isProductOfType } from '@/services/api/parsers/utils';
import Ratings from '@/components/core/components/organism/ratings';
import * as styles from './ratings.styles';

const ProductRatings: UIComponent<{ product: ProductType }> = ({ product }) => {
  if (product.extraInfo.ratings.length === 0) {
    return null;
  }
  return (
    <div className={styles.root}>
      {isProductOfType(product, ['movies', 'series']) && (
        <span className="font-bold">
          <Trans>Ratings</Trans>
        </span>
      )}
      <div className={styles.items}>
        {product.extraInfo.ratings.map((rating) => {
          return <Ratings.Item extra={product.extraInfo} rating={rating} key={rating.source} />;
        })}
      </div>
    </div>
  );
};

export default ProductRatings;
